
  import { Vue, Component, Watch, Prop } from "vue-property-decorator";

  import InputRangeFilter from "@/components/filters/InputRangeFilterNew.vue";
  import FiltersContainer from "@/components/filters/filters-container.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import DateFilterContainer from "@/components/filters/DateFilterContainer.vue";
  import ContractorsMultiselect from "@/components/autocompleteMultiselects/ContractorsMultiselectNew.vue";
  import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiselectNew.vue";
  import ContractorCompaniesMultiselect from "@/components/autocompleteMultiselects/ContractorCompaniesMultiselect.vue";
  import SkillsMultiselect from "@/components/autocompleteMultiselects/SkillsMultiselectNew.vue";
  import IndustriesMultiselect from "@/components/autocompleteMultiselects/IndustriesMultiselectNew.vue";
  import PostedAtSelect from "@/components/autocompleteMultiselects/PostedAtSelectNew.vue";
  import DropdownOption from "@/entities/DropdownOption";
  import UIButton from "@/components/button/ui-button.vue";
  import FormGroup from "@/components/form/FormGroupNew.vue";
  import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelectNew.vue";
  import PostingCityMultiselect from "@/components/autocompleteMultiselects/ProjectCityMultiselectNew.vue";

  import Roles from "@/entities/Roles";
  import ManagementPostingsFiltersQuery from "@/entities/filters/ManagementPostingsFiltersQuery";
  import ContractorPostingsFiltersQuery from "@/entities/filters/ContractorPostingsFiltersQuery";

  import getContractorsMultiselectConditions from '@/helpers/getContractorsMultiselectConditions';
  import getMultiselectValues from "@/helpers/multiselect/getMultiselectValues";
  import RegionInput from "@/components/autocompleteMultiselects/RegionInputCustom.vue";
import UiButtonMessage from "../button/ui-button-message.vue";
import countries, {countriesByNames} from "@/data/locations/countries";

  @Component({
    components: {
      RegionInput,
      UiButton,
      InputRangeFilter,
      SkillsMultiselect,
      IndustriesMultiselect,
      FiltersContainer,
      DateFilterContainer,
      ContractorsMultiselect,
      ManagersMultiselect,
      ContractorCompaniesMultiselect,
      PostedAtSelect,
      FormGroup,
      UIButton,
      ProfileCountrySelect,
      PostingCityMultiselect,
      UiButtonMessage
    },
  })
  export default class PostingFilters extends Vue {
    @Prop({ type: Boolean, default: false }) readonly displayCompaniesFilter!: boolean;
    @Prop({ type: String, default: undefined }) currentUserId?: string;
    @Prop({ type: String, required: true }) currentUserRole!: string;
    @Prop({ type: Object, required: true }) readonly filters!: ManagementPostingsFiltersQuery & ContractorPostingsFiltersQuery;

    jobTitle: string = "";
    skillsIds: number[] = [];
    industries: DropdownOption[] = [];
    countries: DropdownOption[] = [];
    states: DropdownOption[] = [];
    cities: DropdownOption[] = [];
    companies: DropdownOption[] = [];
    contractorsIds: string[] = [];
    managersIds: string[] = [];
    postedAt: string = "";
    minDuration: string = "";
    maxDuration: string = "";

    created(){

      const rCountries = this.$route.query.countries as string
      if(rCountries){
        const routecontries = rCountries.split('|');
        const selectedCountries = []
        routecontries.forEach(r => {
          const country = countriesByNames[r]
          if(country){
            selectedCountries.push(country)
          }


        })
        this.countries = selectedCountries
      }
    }
    get isAdmin(): boolean {
      return this.currentUserRole === Roles.ADMIN;
    }

    get isContractor(): boolean {
      return this.currentUserRole === Roles.CONTRACTOR;
    }

    get countryName(): string {
      return this.countries[0]?.name || "";
    }

    get countriesNames(): string[] {
      return this.countries.map((country) => country.name);
    }

    get statesNames(): string[] {
      return this.states.map((state) => state.name);
    }

    get citiesNames(): string[] {
      return this.cities.map((city) => city.name);
    }

    get companiesNames(): string[] {
      return this.companies.map((company) => company.name);
    }

    get industriesNames(): string[] {
      return this.industries.map((industry) => industry.name);
    }

    get showBorder(): string {
      return !(this.displayCompaniesFilter && this.currentUserId) ? '' : 'border-b';
    }

    get contractorsConditions(): Object {
      return getContractorsMultiselectConditions(this.currentUserRole)
    }

    get propToWatch(): String {
      return JSON.stringify([
        this.jobTitle,
        this.skillsIds,
        this.industriesNames,
        this.contractorsIds,
        this.countriesNames,
        this.statesNames,
        this.citiesNames,
        this.companiesNames,
        this.managersIds,
        this.postedAt,
        this.maxDuration,
        this.minDuration,
      ]);
    }

    @Watch("filters", { immediate: true })
    updateFiltersValues(): void {
      this.jobTitle = this.filters.jobTitle;
      this.skillsIds = this.filters.skills;
      this.industries = getMultiselectValues(this.filters.industries);
      this.countries = this.filters.countries ? getMultiselectValues(this.filters.countries) : [];
      this.states = this.filters.states ?  getMultiselectValues(this.filters.states) : [];
      this.cities = this.filters.cities ? getMultiselectValues(this.filters.cities) : [];
      this.minDuration = this.filters.minDuration;
      this.maxDuration = this.filters.maxDuration;
      this.postedAt = this.filters.postedAt || "";
      this.contractorsIds = this.filters.contractors || [];
      this.managersIds = this.filters.managers || [];
      this.companies = this.filters.companies ? getMultiselectValues(this.filters.companies) : [];
    }

    @Watch("propToWatch")
    handlePropToWatchChange(): void {
      this.$emit("filtersChanged", {
        jobTitle: this.jobTitle,
        minDuration: this.minDuration,
        maxDuration: this.maxDuration,
        skills: this.skillsIds,
        industries: this.industriesNames,
        companies:  this.companiesNames,
        countries: this.countriesNames,
        states: this.statesNames,
        cities: this.citiesNames,
        contractors: this.contractorsIds,
        managers: this.managersIds,
        postedAt: this.postedAt
      });
    }

    handleReset(): void {
      this.$emit("resetFilters");
    }

  }
